document.querySelectorAll('[data-variant-select]').forEach(function (select) {
  select.addEventListener('change', function () {
    var option = select.selectedOptions[0];
    var price = document.querySelector('[data-price]');
    var button = document.querySelector('[data-add]');
    if (price) price.textContent = option.dataset.price;
    if (button) {
      var ok = option.dataset.available === 'true';
      button.disabled = !ok;
      button.textContent = ok ? button.dataset.label : 'Sold out';
    }
  });
});
